import React from 'react'
import EQuotePackageDetailsLandProgram from './EQuotePackageLandProgram'

const EQuotePackageLandPrograms = ({ landPrograms }) => {
  if (!landPrograms || !Object.keys(landPrograms).length) return null
  return (
    <div className="equote__package-details--land-programs">
      <div className="equote__package-details--land-programs--header">
        <h1 className="equote__package-details--land-programs--header--title">
          Land Program Details
        </h1>
      </div>

      {landPrograms.pre ? (
        <EQuotePackageDetailsLandProgram
          landProgram={landPrograms.pre}
          type="pre"
        />
      ) : null}
      {landPrograms.post ? (
        <EQuotePackageDetailsLandProgram
          landProgram={landPrograms.post}
          type="post"
        />
      ) : null}
    </div>
  )
}

export default EQuotePackageLandPrograms
